import { getSocket } from '@src/App';

export default async (gameId: string) => {
  try {
    getSocket().emit('unwatchGame', { gameId });
  } catch (e) {
    console.log(e);
  }
};
